<template>
	<div>
		<Header />
		<div class="con-900 box-white calc category_section mt-60px mb-60px">
			<div class="padding_section">
				<h2 class="fs-title text-center">Mire szeretne biztosítást kötni?</h2>
				<div class="fs-desc">
					Válassza ki, hogy mire (ingatlan, ingóság vagy ingatlan és ingóság) kíván biztosítást kötni!
					Értéktárgy biztosítására ingóság vagy ingóságot is tartalmazó biztosítás választása esetén van
					lehetősége.
				</div>
				<Categories />
				<Login v-if="!isLoggedIn" :minimal="true" />
			</div>
		</div>
	</div>
</template>

<script>
import Categories from '@/components/Categories.vue';
import Login from '@/components/Login.vue';
import Header from '@/components/Header.vue';
import { mapGetters } from 'vuex';

export default {
	components: {
		Header,
		Categories,
		Login,
	},
	computed: {
		...mapGetters('auth', ['isLoggedIn']),
	}
};
</script>
